export const PENDING_SIGNUP_DRAFT_KEY = 'cwy_pending_signup_draft';

export interface PendingSignupDraft {
  name: string;
  email: string;
  password: string;
  confirmPassword: string;
  phoneNumber: string;
  countryIso: string;
  stateIso: string;
}

export const getPendingSignupDraft = (): PendingSignupDraft | null => {
  try {
    const raw = sessionStorage.getItem(PENDING_SIGNUP_DRAFT_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as PendingSignupDraft;
    if (!parsed || typeof parsed !== 'object') return null;
    return parsed;
  } catch {
    return null;
  }
};

export const savePendingSignupDraft = (draft: PendingSignupDraft): void => {
  try {
    sessionStorage.setItem(PENDING_SIGNUP_DRAFT_KEY, JSON.stringify(draft));
  } catch {
    // ignore storage errors (private mode, etc.)
  }
};

export const clearPendingSignupDraft = (): void => {
  try {
    sessionStorage.removeItem(PENDING_SIGNUP_DRAFT_KEY);
  } catch {
    // ignore
  }
};
